import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: var(--size, 32px);
    height: var(--size, 32px);
    background: var(--skeleton-background-color);
    border-radius: 50%;
    position: relative;
    overflow: hidden;
  }

  :host([elevation="0"]) {
    --skeleton-background-color: var(--sds-color-background-default-tertiary);
  }

  :host([elevation="1"]) {
    --skeleton-background-color: var(--sds-color-background-default-secondary);
  }

  :host([elevation="2"]) {
    --skeleton-background-color: var(--sds-color-background-default-default);
  }

  /* Default fallback for elevation 0 */
  :host {
    --skeleton-background-color: var(--sds-color-background-default-tertiary);
  }

  .shimmer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .shimmer::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      color-mix(in hsl, var(--sds-color-background-neutral-secondary), transparent 50%),
      transparent
    );
    animation: shimmer 1.5s ease infinite;
  }

  @keyframes shimmer {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(200%);
    }
  }
`;
